const STATUS_LABELS = {
  DRAFT: "À finaliser",
  PENDING_OTP: "Validation en cours",
  NEW: "Nouvelle demande",
  CONFIRMED: "Confirmée",
  IN_PROGRESS: "En cours",
  DELIVERED: "Livrée",
  INVOICED: "Facturée",
  CANCELLED: "Annulée",
};

const STATUS_STYLES = {
  DRAFT: "bg-gray-100 text-gray-700 border-gray-200",
  PENDING_OTP: "bg-purple-50 text-purple-800 border-purple-200",
  NEW: "bg-blue-50 text-blue-800 border-blue-200",
  CONFIRMED: "bg-yellow-50 text-yellow-800 border-yellow-200",
  IN_PROGRESS: "bg-orange-50 text-orange-800 border-orange-200",
  DELIVERED: "bg-green-50 text-green-800 border-green-200",
  INVOICED: "bg-teal-50 text-teal-800 border-teal-200",
  CANCELLED: "bg-red-50 text-red-800 border-red-200",
};

export default function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || status;
  const cls = STATUS_STYLES[status] || "bg-gray-100 text-gray-700 border-gray-200";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded text-[10px] font-bold uppercase tracking-wider border ${cls}`}
    >
      {label}
    </span>
  );
}

export { STATUS_LABELS };
